module.exports = "pegasus/assets/tech/basic_2/2.png";